import { useQuery, queryOptions } from "@tanstack/react-query";
import { supabase, type Profile } from "@/lib/supabase";
import { useAuth } from "@/hooks/use-auth";

const PROFILE_STALE_TIME = 5 * 60 * 1000;
const PROFILE_GC_TIME = 10 * 60 * 1000;

export function profileQueryOptions(uid: string | null | undefined) {
  return queryOptions({
    queryKey: ["profile", uid],
    enabled: !!uid,
    staleTime: PROFILE_STALE_TIME,
    gcTime: PROFILE_GC_TIME,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", uid!)
        .maybeSingle();
      if (error) throw new Error(error.message || "Network error");
      return (data as Profile | null) ?? null;
    },
  });
}

/**
 * Single source of truth for the current user's profile row. All callers
 * share the same React Query cache entry (`["profile", uid]`) so the row
 * is fetched once per stale window instead of once per consumer.
 */
export function useProfile() {
  const { user } = useAuth();
  return useQuery(profileQueryOptions(user?.id ?? null));
}